<template>
  <div class="opening-cell-renderer">
    <!-- v-if="params.data.entityType === 'account' || params.data.entityType === 'sub-account'" -->
    <el-button
        size="mini">
      {{formatPrice(params.data.foreignBalance ? params.data.foreignBalance : 0)}}
    </el-button>
  </div>
</template>

<script>
export default {
  name: "foreignBalanceCellRenderer",
  methods: {
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
</script>

<style lang="less" scoped>
.opening-cell-renderer {
  width:100%;
  padding:0 5px;
  button {
    width: 100%;
    text-align: right;
    display:flex;
    justify-content: flex-end;
  }
}
</style>
